import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./Feature/loginSlice";
import createTimesheetReducer from "./Feature/createTimesheetSlice";
import tokenReducer from "./Feature/tokenSlice";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, combineReducers({
  user: loginReducer,
  createtimesheet: createTimesheetReducer,
  token: tokenReducer
}))

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk]
})

export const persistor = persistStore(store);

